import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import V2Layout from './V2Layout';

export default function MentionsLegalesV2() {
  const { t } = useTranslation();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <V2Layout>
      <section className="v2-legal-hero">
        <div className="v2-container">
          <span className="v2-pill"><FileText /> {t('footer.legal_mentions')}</span>
          <h1>{t('legal.mentions.title')}</h1>
        </div>
      </section>

      <section className="v2-legal-wrap">
        <div className="v2-container">
          <article className="v2-legal-card">
            <section>
              <h2>{t('legal.mentions.editor')}</h2>
              <p className="v2-legal-pre">{t('legal.mentions.editor_content')}</p>
            </section>
            <section>
              <h2>{t('legal.mentions.director')}</h2>
              <p>{t('legal.mentions.director_content')}</p>
            </section>
            <section>
              <h2>{t('legal.mentions.hosting')}</h2>
              <p className="v2-legal-pre">{t('legal.mentions.hosting_content')}</p>
            </section>
            <section>
              <h2>{t('legal.mentions.intellectual')}</h2>
              <p className="v2-legal-pre">{t('legal.mentions.intellectual_content')}</p>
            </section>
            <section>
              <h2>{t('legal.mentions.responsibility')}</h2>
              <p className="v2-legal-pre">{t('legal.mentions.responsibility_content')}</p>
            </section>
            <section>
              <h2>{t('legal.mentions.cookies')}</h2>
              <p>{t('legal.mentions.cookies_content')}</p>
            </section>
            <section>
              <h2>{t('legal.mentions.law')}</h2>
              <p>{t('legal.mentions.law_content')}</p>
            </section>
          </article>
        </div>
      </section>
    </V2Layout>
  );
}
